import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { allRoles } from './routesObj'

const ViewerRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      rest.isLoggedIn && allRoles.includes(rest.role) ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: '/' }} />
      )
    }
  />
);

export default ViewerRoute;